import { ChangeEvent, Fragment } from 'react';

import { Controller } from 'react-hook-form';
import { InputProps } from './Input';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface InputSwitchProps extends InputProps {
  value?: boolean;
  onChange?: (value: boolean | ChangeEvent<HTMLInputElement>) => void;
}
export default function InputSwitch({
  name,
  defaultValue,
  value,
  onChange,
  control,
  label,
  suffix,
  className,
  isDisabled,
}: InputSwitchProps) {
  const { t } = useTranslation();
  const renderInput = ({
    checked,
    onChange,
  }: {
    checked: boolean;
    onChange: (value: boolean | ChangeEvent<HTMLInputElement>) => void;
  }) => {
    return (
      <div className={classNames('input', 'input--compact', className)}>
        {label && (
          <div className="input__label">
            <label htmlFor={name}>{label}</label>
          </div>
        )}
        <div className="input__container">
          <input
            type="checkbox"
            id={name}
            className="d-none"
            disabled={isDisabled}
            defaultChecked={value ?? (defaultValue as boolean)}
          />
          <div className="d-flex align-items-center">
            <div className="input__switch me-4">
              <button
                type="button"
                disabled={isDisabled}
                className={classNames('input__switch__item', {
                  'input__switch__item--active': checked == null ? !defaultValue : !checked,
                })}
                onClick={() => {
                  if (isDisabled === true) return;
                  onChange?.(false);
                }}
              >
                {t('common.no')}
              </button>
              <button
                type="button"
                disabled={isDisabled}
                className={classNames({
                  input__switch__item: true,
                  'input__switch__item--active': checked == null ? defaultValue : checked,
                })}
                onClick={() => {
                  if (isDisabled === true) return;
                  onChange?.(true);
                }}
              >
                {t('common.yes')}
              </button>
            </div>
            <div className="input__suffix">{suffix}</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Fragment>
      {control ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => {
            return renderInput({
              checked: field.value,
              onChange: field.onChange,
            });
          }}
        />
      ) : (
        renderInput({
          checked: value as boolean,
          onChange: onChange as (value: boolean | ChangeEvent<HTMLInputElement>) => void,
        })
      )}
    </Fragment>
  );
}
